import { api } from '@api'
import { FilterObject, TrailersResponse, VehiclesResponse } from '@types'

export type CarrierVehiclesApiFilters = FilterObject & {
  carrierId: number[]
  limit: number
  equipmentId?: number[]
  disabled?: boolean
}

const getCarrierTrucks = async (filters: CarrierVehiclesApiFilters) => {
  const response = await api.get<VehiclesResponse>('/trucks', { params: filters })
  return response.data.trucks
}

const getCarrierTrailers = async (filters: CarrierVehiclesApiFilters) => {
  const response = await api.get<TrailersResponse>('/trailers', { params: filters })
  return response.data.trailers
}

export { getCarrierTrucks, getCarrierTrailers }
